<template>
  <div class="container">
    <pfx-admin-menu />
    <div v-if="application">
      <h2>Tenant application</h2>

      <h3>Company Details</h3>
      <div>Company Name: {{ application.name }}</div>
      <div>DRE License Number: {{ application.dreNumber }}</div>

      <h3>Contact</h3>
      <div>Phone Number: {{ application.contactPhone }}</div>
      <div>E-mail address: {{ application.contactEmail }}</div>

      <h3>Requested by</h3>
      <div>Name: {{ application.injected.profile.firstName }} {{ application.injected.profile.lastName }}</div>
      <div>Phone Number: {{ application.injected.profile.phone }}</div>
      <div>E-mail address: {{ application.injected.profile.email }}</div>
      <div><small>User ID: {{ application.injected.profile.id }}</small></div>

      <div v-if="existingTenantRole.role" style="color: red; font-size: 1rem; font-weight: 600;">
        <v-icon color="red">warning</v-icon>
        This user already has an active role ({{ existingTenantRole.role | lowercase }}) in another
        tenancy ({{ existingTenantRole.tenant.subdomain }}). This application cannot be accepted before the
        previous role is removed.
      </div>

      <div v-if="application.additionalInfo"><h3>Additional information</h3></div>
      <div v-if="application.additionalInfo">{{ application.additionalInfo }}</div>

      <h3>Requested subdomain</h3>
      <p>
        <input type="text" v-model="application.subdomain" />
        <small>The tenant website address will be: {{ tenantDomain() }}</small>
      </p>

      <div>
        <div>
          <button class="btn-danger" @click="rejectDialog">Remove</button>
          <button class="btn-primary" @click="acceptDialog" :disabled="existingTenantRole.role">Accept application</button>
        </div>
        <small>
          By accepting the tenant application, the platform will create a new public website where the tenant can
          create and publish it's own auctions.
        </small>
      </div>

      <p style="text-align: center; margin-top: 2rem;">
        <router-link to="/pfxadmin/applications">&lt; Back to Applications list</router-link>
      </p>
    </div>
  </div>
</template>

<script>
  import PfxAdminMenu from './PfxAdminMenu.vue'
  import { mapMutations } from 'vuex'

  export default {
    name: 'PfxAdminApplication',
    components: {
      PfxAdminMenu
    },
    data() {
      return {
        pfxLandingPageUrl: process.env.config.frontend.pfxLandingPage,
        tenantApplicationId: this.$route.params.id,
        application: null,
        existingTenantRole: {}
      }
    },
    created() {
      this.loadApplication()
    },
    methods: {
      ...mapMutations([
        'setLoadingSpinner',
        'openDialog'
      ]),

      loadApplication() {
        this.setLoadingSpinner(2)
        this.$PfxBackendApi.getPfxAdminApplication(this.tenantApplicationId).then(res => {
          console.log('getPfxAdminApplication res', res)
          const application = res.data || {}
          application.injected = {}
          application.injected.profile = {}

          this.$PfxBackendApi.getPfxAdminApplicationRole(application.userId).then(res => {
            console.log('getPfxAdminApplicationRole res', res)
            this.existingTenantRole = res.data.tenantRole || {}
          }).catch(err => {
            console.error('getPfxAdminApplicationRole err', err)
            this.$notify({ type: 'danger', message: 'Unexpected error loading existing tenant role' })
          }).then(() => this.setLoadingSpinner('--'))

          this.$PfxBackendApi.getUser(application.userId).then(res => {
            console.log('getUser res', res)
            application.injected.profile = res.data || {}
          }).catch(err => {
            console.error('getUser err', err)
          }).then(() => this.setLoadingSpinner('--'))
          this.application = application

        }).catch(err => {
          console.error('getPfxAdminApplication err', err)
          this.$notify({ type: 'danger', message: 'Unexpected error during loading application' })
          if (err.data.message) {
            this.$notify({ type: 'danger', message: err.data.message })
          }
          this.setLoadingSpinner(false)
        })
      },

      tenantDomain() {
        return this.pfxLandingPageUrl.replace(/\/\//, '//' + this.application.subdomain + '.')
      },

      acceptDialog() {
        if (this.existingTenantRole.role) {
          return
        }
        this.$store.commit('openDialog', {
          text: 'You are about to accept the tenant application. This will create a new PFX powered website. Continue?',
          buttons: [
            { title: 'Cancel', class: 'btn-neutral' },
            { title: 'Create new tenant',
              handler: () => {
                this.$store.commit('closeDialog')
                this.accept()
              }
            }
          ]
        })
      },

      accept() {
        this.setLoadingSpinner(true)
        const data = {
          subdomain: this.application.subdomain,
          name: this.application.name,
          dreNumber: this.application.dreNumber,
          officePhone: this.application.contactPhone,
          companyEmail: this.application.contactEmail
        }
        console.warn('acceptPfxAdminApplication', data)
        this.$PfxBackendApi.acceptPfxAdminApplication(this.tenantApplicationId, data).then(res => {
          console.log('acceptPfxAdminApplication res', res)
          this.$router.push('/pfxadmin/applications')
        }).catch(err => {
          console.error('acceptPfxAdminApplication err', err)
          this.$notify({ type: 'danger', message: 'Unexpected error during accepting application' })
          if (err.data.message) {
            this.$notify({ type: 'danger', message: err.data.message })
          }
        }).then(() => this.setLoadingSpinner(false))
      },

      rejectDialog() {
        this.$store.commit('openDialog', {
          text: 'You are about to reject and delete the tenant application. This cannot be undone. Continue?',
          buttons: [
            { title: 'Cancel', class: 'btn-neutral' },
            { title: 'Remove', class: 'btn-danger',
              handler: () => {
                this.$store.commit('closeDialog')
                this.reject()
              }
            }
          ]
        })
      },

      reject() {
        this.setLoadingSpinner(true)
        this.$PfxBackendApi.deletePfxAdminApplication(this.tenantApplicationId).then(res => {
          console.log('deletePfxAdminApplication res', res)
          this.$router.push('/pfxadmin/applications')

        }).catch(err => {
          console.error('deletePfxAdminApplication err', err)
          this.$notify({ type: 'danger', message: 'Unexpected error during removing application' })
          if (err.data.message) {
            this.$notify({ type: 'danger', message: err.data.message })
          }
        }).then(() => this.setLoadingSpinner(false))
      }

    }
  }
</script>

<!--
<style lang="scss" scoped>
  @import 'node_modules/jeet/scss/index';
</style>
-->



// WEBPACK FOOTER //
// src/components/PfxAdminApplication.vue